module.exports = __webpack_public_path__ + "img/car-main-back.c50aded8.png";